import React from 'react';
import { useAtomValue } from 'jotai';
import { getAnnotationStyle } from '../../../../../../common/utils/utils';
import { isVideoLabelingM4EnabledAtom } from '../../../../../labelling-v2/atoms/m4-atoms';
import { useStageAtoms } from '../../../../../labelling-v2/components/stage-scope/hooks';
import type { SkeletonPreviewStyleT, SkeletonTemplateT } from '../../../../types';
import { SKELETON_PREVIEW_STYLE } from '../constants';
import { useDrawSkeletonViaTemplate } from '../use-draw-skeleton-via-template';
import { PreviewBoundingBox } from './preview-bounding-box';
import { PreviewEdges } from './preview-edges';
import { PreviewNodes } from './preview-nodes';
type PropsT = {
  isDrawing: boolean;
  templateConfig: SkeletonTemplateT;
};
export const SkeletonWithTemplate = ({
  isDrawing,
  templateConfig
}: PropsT) => {
  const {
    selectedAnnotationLabelAtom
  } = useStageAtoms();
  const annotationLabel = useAtomValue(selectedAnnotationLabelAtom);
  const isVideoLabelingM4Enabled = useAtomValue(isVideoLabelingM4EnabledAtom);
  const {
    stampBox,
    previewSkeleton
  } = useDrawSkeletonViaTemplate({
    isDrawing,
    templateConfig
  });
  if (!stampBox || !annotationLabel) return null;
  const annotationStyle = getAnnotationStyle(annotationLabel.style, {
    isFocused: false,
    isLocked: false,
    useStageStrokeWidth: true,
    isM4: isVideoLabelingM4Enabled
  });
  const previewStyle: SkeletonPreviewStyleT = {
    strokeColor: annotationStyle.stroke ?? annotationStyle.strokeColor ?? SKELETON_PREVIEW_STYLE.DEFAULT_COLOR,
    strokeWidth: annotationStyle.strokeWidth
  };
  return <g data-testid="skeleton-with-template-preview">
      <PreviewBoundingBox box={stampBox} style={previewStyle} />
      {previewSkeleton && <>
          <PreviewEdges edges={previewSkeleton.edges} nodes={previewSkeleton.nodes} style={previewStyle} />
          <PreviewNodes nodes={previewSkeleton.nodes} style={previewStyle} />
        </>}
    </g>;
};